export const IN_SHELL = 'IN_SHELL';
export const IN_MACHINE = 'IN_MACHINE';
export const IN_MACHINE_1 = 'IN_MACHINE_1';
export const IN_MACHINE_2 = 'IN_MACHINE_2';
export const IN_MACHINE_3 = 'IN_MACHINE_3';
